import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
   {
      path: '/',
      redirect: 'desbloqueio-periodo',
      component: LayoutPadrao,
      children: [
         {
            path: '/desbloqueio-periodo',
            name: 'desbloqueio-periodo',
            component: () => import('../pages/DesbloqueioPeriodo.vue')
         }
      ]
   },
   {
      path: '/',
      redirect: 'listar-desbloqueio-periodo',
      component: LayoutPadrao,
      children: [
         {
            path: '/listar-desbloqueio-periodo',
            name: 'listar-desbloqueio-periodo',
            component: () => import('../pages/ListarPeriodosDesbloqueados.vue')
         }
      ]
   }
]
